import { Cookies } from 'react-cookie';
import { useRouter } from 'next/router';

import { usePdpConfig } from '../context/ConfigContext';

export const useCatalogProductIdParams = () => {
  const router = useRouter();
  const { isProductPreview, catalogProductId } = usePdpConfig();
  const catalog_product_id =
    isProductPreview && catalogProductId
      ? catalogProductId
      : [router?.query.catalog_product_id, router?.query.id, router?.query.product_id].find(Boolean)?.toString() || '';

  const cookies = new Cookies();
  const utm_source = router?.query.utm_source?.toString();
  const utm_source_cookie = cookies.get('utm_source');

  return {
    catalog_product_id,
    utm_source: utm_source || utm_source_cookie,
  };
};
